import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { BetByRequest } from "../models/requests/betByRequest";
import { BetByResponse } from "../models/responses/betByResponse";

export const BetByGameLaunchApi = {

  /* BetBy(Sportsbook Plus) game launch */
  betByLaunch: async (
    request: BetByRequest
  ): Promise<UnifiedResponse<BetByResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<BetByResponse>
      >("/game/retrieve_betby_withtoken/launch_details", request);

    return response.data;
  },

  betByLaunchWithoutToken: async (
    request: BetByRequest
  ): Promise<UnifiedResponse<BetByResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<BetByResponse>
      >("/game/retrieve_betby/launch_details", request,
        {
          headers: {
            requiresAuth: false,
          },
        });

    return response.data;
  },
};
